<template>
    <layout-user containerClass="bg-white">
		<form autocomplete="off" @submit.prevent="register" method="post" data-vv-scope="form">
			<div class="row  mt-2 mt-sm-0 mb-3">
				<div class="col-sm-12">
					<h1 class="title text-center text-sm-left">{{this.pageTitle}}</h1>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12">
					<MaterialInput
						type="text"
						class="city-form-group city-bg form-xl"
						id="input-name"
						name="name"
						v-model.trim="form.body.name"
						v-validate="'required|min:3'"
						:inputClasses="['form-control-xl', {'is-invalid': $root.fnHasError('form.name',this)}]"
						:error="errors.first('form.name')">
						Nome
					</MaterialInput>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12">
					<MaterialInput
						type="text"
						class="city-form-group city-bg form-xl"
						id="input-email"
						name="email"
						v-model.trim="form.body.email"
						v-validate="'required|email'"
						:inputClasses="['form-control-xl', {'is-invalid': $root.fnHasError('form.email',this)}]"
						:error="errors.first('form.email')">
						Email
					</MaterialInput>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12">
					 <MaterialInput
						type="password"
						class="city-form-group city-bg form-xl"
						id="input-password"
						name="password"
						v-model.trim="form.body.password"
						ref="password"
						v-validate="{required: true, min: getMinPasswordLength()}"
						:inputClasses="['form-control-xl', {'is-invalid': fnHasError('password') }]"
                        :error="fnFirstError('password')">
						Password
					</MaterialInput>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12">
					<MaterialInput
						type="password"
						class="city-form-group city-bg form-xl"
						id="input-password-confirm"
						name="password_confirmation"
						v-model.trim="form.body.password_confirmation"
						data-vv-as="password"
						v-validate="'required|confirmed:password'"
						:inputClasses="['form-control-xl', {'is-invalid': fnHasError('password_confirmation') }]"
                        :error="fnFirstError('password_confirmation')">
						Confirmar Password
					</MaterialInput>
				</div>
			</div>
			<div class="row">
				<div class="" :class="[enableNIF ? 'col-sm-6' : 'col-sm-12']">
					 <MaterialInput
					 	type="text"
					 	class="city-form-group city-bg form-xl"
						id="input-phone"
						name="phone"
						v-model.trim="form.body.phone"
						:helpText="help.phone"
						v-validate="'phone'"
						:inputClasses="['form-control-xl', {'is-invalid': fnHasError('phone') }]"
                        :error="fnFirstError('phone')">
						Telefone
					</MaterialInput>
				</div>
				<div class="col-sm-6" v-if="enableNIF">
					<MaterialInput
						type="text"
						class="city-form-group city-bg form-xl"
						id="input-nif"
						name="nif"
						v-model.trim="form.body.nif"
						:inputClasses="['form-control-xl']">
						NIF
					</MaterialInput>
				</div>
			</div>
			<div class="row justify-content-center pt-sm-3">
				<div class="col-12 col-sm-6 mx-0 order-2 order-sm-1">
					<router-link
						:to="{ name: 'portal.login' }"
						class="btn btn-outline-main btn-rounded btn-lg btn-responsive min-w-auto z-depth-0 btn-block">
						{{ this.cancelTitle }}
					</router-link>
				</div>
				<div class="col-12 col-sm-6 mx-0 order-1 order-sm-2">
					<button
						class="btn btn-main btn-rounded btn-lg btn-responsive min-w-auto z-depth-0 btn-block mb-3 mb-sm-0 text-nowrap"
						type="submit"
						:disabled="isDisabled">
						{{ this.submitTitle }}
					</button>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-center">
					<hr>
					<!-- Terms of service -->
		            <p>Ao clicar em
		                <em>{{ this.submitTitle }}</em>, você concorda com os nossos
		                <router-link :to="routerLink(getSlugPageType('terms'))">termos de serviço</router-link>
		            </p>
				</div>
			</div>
		</form>

    </layout-user>
</template>

<script>
	import mixin from '../../mixin'
    import { mapGetters } from 'vuex';
	import LayoutUser from '../../layouts/User';

	export default {
	    mixins: [mixin],
	    components: {
	        'layout-user': LayoutUser,
	    },
		data() {
			return {
				pageTitle: 'Registar',
				submitTitle: 'Criar conta',
				cancelTitle: 'Cancelar',
				help: {
					phone: 'Caso pretenda ser contatado pelo Município',
				},
				form: {
					body: {
						name: null,
						phone: null,
						nif: null,
						email: null,
						password: null,
						password_confirmation: null
                    },
					remember: false,
                    fetchUser: false,
                    autoLogin: false,
                    staySignedIn: false,
				},
			}
		},
        computed: {
            ...mapGetters({
                getSlugPageType: 'getSlugPageType',
                registerConfig: 'registerConfig',
            }),
			enableNIF() {
				return !!this.registerConfig.enableNIF;
			},
        },
		methods: {
			routerLink: function(slug) {
				return this.getRouterLinkFromPage(null, {slug});
			},
			register() {
				var app = this;
				this.clearMessages();

				this.$validator.validateAll('form')
				.then(result => {
					if (!result) {
						this.showError('Por favor corrija os erros no formulário', this.pageTitle);
						return;
					}

					this.$auth.register({
                        data: this.form.body,
                        fetchUser: this.form.fetchUser,
                        autoLogin: this.form.autoLogin,
                        staySignedIn: this.form.staySignedIn,
					}).then((res) => {
						if (this.form.remember) {
                            this.$auth.remember(JSON.stringify({
                                name: this.$auth.user().name
                            }));
                        }

						this.showMessage(res.data.data, this.pageTitle, 'success', () => {
							this.$router.push({name: 'portal.login', params: {successRegistrationRedirect: true}})
						}, 6000);

					}).catch((error) => {
						this.showHttpError(error);
					});
				});
			}
		}
	}
</script>

<style scoped lang="scss">
.reset-password{
	padding-left:0px;
}
</style>
